import { Link, Stack, styled } from "@mui/material";
import React from "react";
import logo from "../../images/horizontail-white-logo.jpg";
import { useNavigate } from "react-router-dom";

const NavLink = styled(Link)({
  textDecoration: "none",
  cursor: "pointer",

  ":hover": {
    transform: "none",
    // backgroundColor: "#14a37f",
    borderRadius: 8,
    fontWeight: 500
  },
  ":active": {}
});

const TopLinksNavigation = () => {
  const navigate = useNavigate();
  


  return (
    <Stack
      height={65}
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={2}
      sx={{ backgroundColor: "#FFFFFF" }}
    >
      <NavLink
        href="https://invoices.fasset.org.za/"
        target="_blank"
        rel="noreferrer"
      >
        INVOICE MANAGEMENT
      </NavLink>
      <NavLink
        href="https://portal.fasset.org.za/"
        target="_blank"
        rel="noreferrer"
      >
        ODOO LMIS
      </NavLink>

      <img
        src={logo}
        width={160}
        height={65}
        alt=""
        onClick={() => navigate("/home")}
      />

      
      <NavLink
        href="https://www.learner-portal.fasset.org.za"
        target="_blank"
        rel="noreferrer"
      >
        LEARNER PORTAL
      </NavLink>

      <NavLink
        onClick={() => navigate("/articles")}
        sx={{ cursor: "pointer" }}
      >
        ARTICLES
      </NavLink>
    </Stack>
  );
};

export default TopLinksNavigation;
